import React, { type FC } from 'react'
import { type FundingRequestTest } from '../utils/types'
import { formatKey } from '../../../utility/formatting'
import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import type { ColDef, ICellRendererParams } from 'ag-grid-community'

const FRTestSection: FC<{ data: FundingRequestTest | null }> = ({ data }) => {
  if (!data) return null

  const testEntries = Object.entries(data).filter(
    ([key]) => key !== '__typename'
  ) as Array<[keyof Omit<FundingRequestTest, '__typename'>, string]>

  const rowData = testEntries.map(([key, value]) => ({
    test: formatKey(key.toString()),
    result: value?.toUpperCase() ?? 'N/A'
  }))

  const columnDefs: ColDef[] = [
    {
      headerName: 'Test',
      field: 'test',
      flex: 1,
      cellClass: 'font-medium text-sm',
      suppressMovable: true
    },
    {
      headerName: 'Result',
      field: 'result',
      width: 120,
      suppressMovable: true,
      cellRenderer: (params: ICellRendererParams) => {
        const result = params.value
        let color, text

        switch (result) {
          case 'PASS':
            color = 'bg-green-300 text-green-800'
            text = 'PASS'
            break
          case 'FAIL':
            color = 'bg-red-300 text-red-800'
            text = 'FAIL'
            break
          case 'MISSING':
            color = 'bg-red-300 text-red-800'
            text = 'MISSING'
            break
          default:
            color = 'bg-gray-300 text-gray-800'
            text = 'N/A'
        }

        return (
          <div className={`text-xs font-semibold px-3 py-1 rounded-full text-center ${color}`}>
            {text}
          </div>
        )
      }
    }
  ]

  return (
    <div className="space-y-2 gray-200 rounded-lg p-4 bg-white">
      <h3 className="mb-2 font-bold">Test Results</h3>
      <div className="ag-theme-alpine w-full">
        <AgGridReact
          columnDefs={columnDefs}
          rowData={rowData}
          domLayout="autoHeight"
          headerHeight={32}
          rowHeight={40}
          suppressMovableColumns
        />
      </div>
    </div>
  )
}

export default FRTestSection
